var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4224 19.35C15.3449 20.8913 17.0436 21.9375 18.9899 21.9375C20.9361 21.9375 22.6349 20.9025 23.5574 19.35C24.0524 18.54 24.3336 17.595 24.3336 16.5938C24.3336 13.6463 21.9374 11.25 18.9899 11.25M14.4224 19.35C13.9274 18.5513 13.6461 17.595 13.6461 16.5938M14.4224 19.35C13.9274 18.54 13.6461 17.595 13.6461 16.5938M14.4224 19.35C14.8386 20.0475 15.4124 20.6437 16.1099 21.0712V21.4538C16.1099 22.14 15.6599 23.0512 15.0861 23.3887L13.4999 24.4125C12.0261 25.3238 9.97863 24.3 9.97863 22.4775V16.4588C9.97863 15.66 9.51738 14.6363 9.06738 14.0738L4.74738 9.52872C4.18488 8.95497 3.72363 7.93126 3.72363 7.25626V4.63499C3.72363 3.27374 4.74738 2.25 5.99613 2.25H21.0036C22.2524 2.25 23.2761 3.27377 23.2761 4.52252V7.01999C23.2761 7.93124 22.7024 9.06751 22.1399 9.64126L20.1599 11.385C19.7886 11.295 19.3949 11.25 18.9899 11.25M13.6461 16.5938C13.6461 13.6463 16.0424 11.25 18.9899 11.25M20.9924 16.5712H16.9986M18.9899 14.625V18.6187",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAdd);
export default __webpack_public_path__ + "static/media/FilterAdd.0b6c7bef53d37f07de573b134acae5c9.svg";
export { ForwardRef as ReactComponent };